/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Back Button Component
 * Used for all wizards and Page Product
 *
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.10.0
 */

import { memo, MouseEvent, useCallback } from 'react';

import styled from 'styled-components';

import { arrowBackIcon } from '../../../assets/icons';
import { fonts } from '../../../theme';
import { ImgStyled } from '../Block/Img';

export const BackButtonStyled = styled.div.attrs({
    'data-name': 'backButton',
})`
    cursor: pointer;
    display: inline-flex;

    ${fonts.textMainBold};
    line-height: 20px;

    ${ImgStyled} {
        display: inline-block;
        margin-right: 12px;
    }
`;

export interface IBackButtonProps {
    disabled?: boolean;
    title?: string;
    onClick: (event: MouseEvent) => void;
}

const BackButton = (props: IBackButtonProps) => {

    const { disabled, onClick } = props;

    const onClickHandler = useCallback((event: MouseEvent) => {
        if (!disabled) {
            onClick(event);
        }
    }, [disabled, onClick])

    return <BackButtonStyled onClick={onClickHandler}>
        <ImgStyled height="20px" src={arrowBackIcon} width="40px"/>
        {props.title ?? ''}
    </BackButtonStyled>
};

export default memo(BackButton);
